import Big from 'big.js';

import {
  countryCodeByMethod,
  DepositBank,
  DepositMethod,
  DepositTransferType,
} from 'data/payments/models';

import { BrowserInfo, MobileOS } from './browserInfo';

// const ALFA_IOS = [
//   'aconsierge://transfers/phone',
//   'splitactivities://transfers/phone',
//   'triptally://transfers/phone',
//   'alfabank://transfers/phone',
//   'kittycash://transfers/phone',
//   'cashline://transfers/phone',
//   'assistmekz://transfers/phone',
//   'aweassist://transfers/phone',
//   'smartfinancementor://transfers/phone',
// ];
// const ALFA_ANDROID = ['alfabank://payments_hub'];

const SBER_ANDROID_TG_SBP = [
  'intent://ru.sberbankmobile/android-app/ru.sberbankmobile/transfers/overseas/search',
];
const SBER_ANDROID_CARD = [
  'intent://ru.sberbankmobile/payments/p2p?type=card_number&requisiteNumber={cardNumber}',
];
const SBER_ANDROID_SBP = [
  'intent://ru.sberbankmobile/payments/p2p?type=phone_number&requisiteNumber={phoneNumber}',
];
const SBER_ANDROID_MOBCOM = [
  'intent://ru.sberbankmobile/payments/services/mobile',
];
const SBER_ANDROID_VND_QR = [
  'intent://ru.sberbankmobile/qrpay?qrPayLinkKey={qrcode}',
];

const SBER_IOS_SBP = [
  'onlineios-app://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={phoneNumber}&type=phone',
  'onlineappmobile://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={phoneNumber}&type=phone',
  'btripsexpenses://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={phoneNumber}&type=phone',
  'budgetonline-ios://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={phoneNumber}&type=phone',
  'sbolidexternallogin://p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={phoneNumber}&type=phone',
  'ios-app-smartonline://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={phoneNumber}&type=phone',
];
const SBER_IOS_TG_SBP = [
  'onlineios-app://sbolonline/transfers/overseas',
  'onlineappmobile://sbolonline/transfers/overseas',
  'btripsexpenses://sbolonline/transfers/overseas',
  'budgetonline-ios://sbolonline/transfers/overseas',
  'sbolidexternallogin://sbolonline/transfers/overseas',
  'ios-app-smartonline://sbolonline/transfers/overseas',
];
const SBER_IOS_CARD = [
  'onlineios-app://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={cardNumber}&type=card',
  'onlineappmobile://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={cardNumber}&type=card',
  'btripsexpenses://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={cardNumber}&type=card',
  'budgetonline-ios://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={cardNumber}&type=card',
  'sbolidexternallogin://p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={cardNumber}&type=card',
  'ios-app-smartonline://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={cardNumber}&type=card',
];
const SBER_IOS_MOBCOM = [
  'onlineios-app://sbolonline/payments/mobile',
  'onlineappmobile://sbolonline/payments/mobile',
  'btripsexpenses://sbolonline/payments/mobile',
  'budgetonline-ios://sbolonline/payments/mobile',
  'sbolidexternallogin://payments/mobile',
  'ios-app-smartonline://sbolonline/payments/mobile',
];

const T_BANK_ANDROID_SBP = [
  'tbank://Main/PayByMobileNumber?numberPhone=%2B{phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
];
const T_BANK_ANDROID_CARD = [
  'tbank://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
];
const T_BANK_ANDROID_MOBCOM = [
  'tbank://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
];

const T_BANK_IOS_SBP = [
  'bank100000000004://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'towncenter://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'gymapp://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'wheels://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'clanstrix://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'catch://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'freelancecase://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'outpharmas://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'yellowt://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'tbank://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'mobtrs://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'tinkoffbank://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'feedaways://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'toffice://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'tguard://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'shuttersmart://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'petraise://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'goaloriented://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'tmydocs://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'tfinstudy://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'tsplit://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
  'tfinskills://Main/PayByMobileNumber?numberPhone={phoneNumber}&amount={amount}&workflowType=RTLNTransfer',
];
const T_BANK_IOS_CARD = [
  'bank100000000004://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'towncenter://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'gymapp://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'wheels://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'clanstrix://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'catch://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'freelancecase://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'outpharmas://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'yellowt://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'tbank://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'mobtrs://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'tinkoffbank://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'feedaways://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'toffice://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'tguard://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'shuttersmart://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'petraise://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'goaloriented://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'tmydocs://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'tfinstudy://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'tsplit://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
  'tfinskills://Main/Pay/C2C?amount={amount}&targetCardNumber={cardNumber}&numberCard={cardNumber}',
];
const T_BANK_IOS_MOBCOM = [
  'bank100000000004://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'towncenter://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'gymapp://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'wheels://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'clanstrix://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'catch://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'freelancecase://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'outpharmas://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'yellowt://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'tbank://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'mobtrs://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'tinkoffbank://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'feedaways://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'toffice://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'tguard://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'shuttersmart://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'petraise://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'goaloriented://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'tmydocs://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'tfinstudy://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'tsplit://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
  'tfinskills://Main/Pay?Provider={provider}&phone={phoneNumber}&amount={amount}',
];

const VTB_ANDROID_SBP = [
  'vtb://online.vtb.ru/i/world/{country}/{bankId}/?phoneNumber={phoneNumber}&deeplink=true',
];
const VTB_ANDROID_SBP_NO_BANK_ID = ['vtb://online.vtb.ru/i/phone/{country}'];
const VTB_ANDROID_CARD = ['vtb://online.vtb.ru/i/world/{country}'];
const VTB_ANDROID_MOBCOM = ['vtb://online.vtb.ru/i/pay/c/Mobile'];
const VTB_ANDROID_QR = ['vtb://online.vtb.ru/i/tqr?qrCode={qrcode}'];

const VTB_IOS_SBP = [
  'loona://online.vtb.ru/i/world/{country}/{bankId}/?phoneNumber={phoneNumber}&deeplink=true',
];
const VTB_IOS_SBP_NO_BANK_ID = ['loona://online.vtb.ru/i/phone/{country}'];
const VTB_IOS_CARD = ['loona://online.vtb.ru/i/world/{country}'];
const VTB_IOS_MOBCOM = ['loona://online.vtb.ru/i/pay/c/Mobile'];
const VTB_IOS_QR = ['loona://online.vtb.ru/i/tqr?qrCode={qrcode}'];

export const deepLinks: Record<
  MobileOS,
  Record<
    DepositBank,
    Partial<
      Record<DepositMethod, Partial<Record<DepositTransferType, string[]>>>
    >
  >
> = {
  android: {
    Сбербанк: {
      SBP: { SBP: SBER_ANDROID_SBP },
      SBP_CLASSIC: { SBP: SBER_ANDROID_SBP },
      AMD_TG_SBP: { SBP: SBER_ANDROID_TG_SBP },
      CARD: { CARD: SBER_ANDROID_CARD },
      CARD_CLASSIC: { CARD: SBER_ANDROID_CARD },
      AMD_TG_CARD: { CARD: SBER_ANDROID_CARD },
      AMD_TG: { SBP: SBER_ANDROID_TG_SBP, CARD: SBER_ANDROID_CARD },
      TJS_TG: { SBP: SBER_ANDROID_TG_SBP, CARD: SBER_ANDROID_CARD },
      UZS_TG: { SBP: SBER_ANDROID_TG_SBP, CARD: SBER_ANDROID_CARD },
      MOBCOM: { SBP: SBER_ANDROID_MOBCOM },
      VND_TG_QR: { QR: SBER_ANDROID_VND_QR },
      PHP_TG_QR: { QR: SBER_ANDROID_VND_QR },
      //   ACCOUNT: [
      //     'intent://ru.sberbankmobile/payments/p2p?type=account_number&requisiteNumber={accountNumber}',
      //   ],
      //   MOBILE: [
      //     'intent://ru.sberbankmobile/android-app/ru.sberbankmobile/payments/services/init?psh=p&did=1755684725085000782&cs={operatorCode}',
      //   ],
    },
    'Т-Банк': {
      SBP: { SBP: T_BANK_ANDROID_SBP },
      SBP_CLASSIC: { SBP: T_BANK_ANDROID_SBP },
      AMD_TG_SBP: { SBP: T_BANK_ANDROID_SBP },
      CARD: { CARD: T_BANK_ANDROID_CARD },
      CARD_CLASSIC: { CARD: T_BANK_ANDROID_CARD },
      AMD_TG_CARD: { CARD: T_BANK_ANDROID_CARD },
      AMD_TG: { CARD: T_BANK_ANDROID_CARD, SBP: T_BANK_ANDROID_SBP },
      TJS_TG: { CARD: T_BANK_ANDROID_CARD, SBP: T_BANK_ANDROID_SBP },
      UZS_TG: { CARD: T_BANK_ANDROID_CARD, SBP: T_BANK_ANDROID_SBP },
      MOBCOM: { SBP: T_BANK_ANDROID_MOBCOM },
    },
    ВТБ: {
      SBP: { SBP: VTB_ANDROID_SBP_NO_BANK_ID },
      SBP_CLASSIC: { SBP: VTB_ANDROID_SBP_NO_BANK_ID },
      AMD_TG_SBP: { SBP: VTB_ANDROID_SBP },
      CARD: { CARD: VTB_ANDROID_CARD },
      CARD_CLASSIC: { CARD: VTB_ANDROID_CARD },
      AMD_TG_CARD: { CARD: VTB_ANDROID_CARD },
      AMD_TG: { CARD: VTB_ANDROID_CARD, SBP: VTB_ANDROID_SBP },
      UZS_TG: { CARD: VTB_ANDROID_CARD, SBP: VTB_ANDROID_SBP },
      TJS_TG: { CARD: VTB_ANDROID_CARD, SBP: VTB_ANDROID_SBP },
      MOBCOM: { SBP: VTB_ANDROID_MOBCOM },
      VND_TG_QR: { QR: VTB_ANDROID_QR },
      PHP_TG_QR: { QR: VTB_ANDROID_QR },
    },
    'МТС Банк': {},
    'Альфа банк': {},
  },
  ios: {
    Сбербанк: {
      SBP: { SBP: SBER_IOS_SBP },
      SBP_CLASSIC: { SBP: SBER_IOS_SBP },
      AMD_TG_SBP: { SBP: SBER_IOS_TG_SBP },
      CARD: { CARD: SBER_IOS_CARD },
      CARD_CLASSIC: { CARD: SBER_IOS_CARD },
      AMD_TG_CARD: { CARD: SBER_IOS_CARD },
      AMD_TG: { CARD: SBER_IOS_CARD, SBP: SBER_IOS_TG_SBP },
      TJS_TG: { CARD: SBER_IOS_CARD, SBP: SBER_IOS_TG_SBP },
      UZS_TG: { CARD: SBER_IOS_CARD, SBP: SBER_IOS_TG_SBP },
      MOBCOM: { SBP: SBER_IOS_MOBCOM },
      //   ACCOUNT: [
      //     'onlineios-app://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={accountNumber}&type=account',
      //     'onlineappmobile://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={accountNumber}&type=account',
      //     'btripsexpenses://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={accountNumber}&type=account',
      //     'budgetonline-ios://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={accountNumber}&type=account',
      //     'sbolidexternallogin://p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={accountNumber}&type=account',
      //     'ios-app-smartonline://sbolonline/p2ptransfer?amount={amount}&isNeedToOpenNextScreen=true&skipContactsScreen=true&to={accountNumber}&type=account',
      //   ],
      //   MOBILE: [
      //     'onlineios-app://sbolonline/payments/services/init?psh=p&did=1755684725085000782&cs={operatorCode}',
      //     'onlineappmobile://sbolonline/payments/services/init?psh=p&did=1755684725085000782&cs={operatorCode}',
      //     'budgetonline-ios://sbolonline/payments/services/init?psh=p&did=1755684725085000782&cs={operatorCode}',
      //     'ios-app-smartonline://sbolonline/payments/services/init?psh=p&did=1755684725085000782&cs={operatorCode}',
      //     'btripsexpenses://sbolonline/payments/services/init?psh=p&did=1755684725085000782&cs={operatorCode}',
      //     'sbolonline://payments/services/init?psh=p&did=1755684725085000782&cs={operatorCode}',
      //   ],
    },
    'Т-Банк': {
      SBP: { SBP: T_BANK_IOS_SBP },
      SBP_CLASSIC: { SBP: T_BANK_IOS_SBP },
      AMD_TG_SBP: { SBP: T_BANK_IOS_SBP },
      CARD: { CARD: T_BANK_IOS_CARD },
      CARD_CLASSIC: { CARD: T_BANK_IOS_CARD },
      AMD_TG_CARD: { CARD: T_BANK_IOS_CARD },
      AMD_TG: { CARD: T_BANK_IOS_CARD, SBP: T_BANK_IOS_SBP },
      TJS_TG: { CARD: T_BANK_IOS_CARD, SBP: T_BANK_IOS_SBP },
      UZS_TG: { CARD: T_BANK_IOS_CARD, SBP: T_BANK_IOS_SBP },
      MOBCOM: { SBP: T_BANK_IOS_MOBCOM },
    },
    ВТБ: {
      SBP: { SBP: VTB_IOS_SBP_NO_BANK_ID },
      SBP_CLASSIC: { SBP: VTB_IOS_SBP_NO_BANK_ID },
      AMD_TG_SBP: { SBP: VTB_IOS_SBP },
      CARD: { CARD: VTB_IOS_CARD },
      CARD_CLASSIC: { CARD: VTB_IOS_CARD },
      AMD_TG_CARD: { CARD: VTB_IOS_CARD },
      AMD_TG: { CARD: VTB_IOS_CARD, SBP: VTB_IOS_SBP },
      TJS_TG: { CARD: VTB_IOS_CARD, SBP: VTB_IOS_SBP },
      UZS_TG: { CARD: VTB_IOS_CARD, SBP: VTB_IOS_SBP },
      MOBCOM: { SBP: VTB_IOS_MOBCOM },
      VND_TG_QR: { QR: VTB_IOS_QR },
      PHP_TG_QR: { QR: VTB_IOS_QR },
    },
    'МТС Банк': {},
    'Альфа банк': {},
  },
};

const bankIds: Record<string, string> = {
  'My Babilon': '10128',
  'My Tcell': '10126',
  'Paykar Wallet': '160',
  'Shukr Moliya': '150',
  'Азизи-Молия': '8',
  'Актив Банк': '84',
  'Алиф Банк': '5',
  Амонатбанк: '29',
  Арванд: '86',
  'Ардо-Капитал': '7',
  'Банк Арванд': '9',
  'Банк Эсхата': '27',
  ВАСЛ: '147',
  'Душанбе Сити': '4',
  'Коммерцбанк Таджикистана': '18',
  'МДО "Зудамал"': '10118',
  'МДО "Пайванд Групп"': '10088',
  'МДО Фуруз': '10161',
  Матин: '83',
  'Международный банк Таджикистана': '28',
  'ООО МДО ЛОЛС МОЛИЯ': '10212',
  Ориёнбанк: '74',
  'Сандук МДО': '200000000027',
  Саноатсодиротбонк: '14',
  Спитамен: '73',
  'Тавхид банк': '15',
  'Фазо С МДО': '200000000038',
  Хумо: '85',
  'Хумо Онлайн': '16',
  'Эмин Сармоя МДО': '200000000035',
  'Fast Shift': '10111',

  'AVO Банк': '39',
  Anorbank: '43',
  'Apex Bank': '41',
  'Asia Alliance Bank': '50',
  'Garant bank': '57',
  Hamkorbank: '63',
  'Hayot Bank': '67',
  'KDB Bank Uzbekistan': '52',
  NBU: '56',
  Octobank: '49',
  'Poytaxt bank': '66',
  'TBC Bank': '44',
  'Tenge Bank': '59',
  'Uzum bank': '40',
  'Xalq bank': '55',
  'Yangi Bank': '68',
  'Ziraat Bank': '48',
  Агробанк: '46',
  Алокабанк: '54',
  Асакабанк: '36',
  'Давр Банк': '45',
  Инфинбанк: '37',
  'Ипотека банк': '34',
  'Йпак Йули Банк': '58',
  Капиталбанк: '61',
  'Кишлок курилиш банк': '53',
  'Мадад Инвест Банк': '38',
  Микрокредитбанк: '62',
  'Ориент Финанс Банк': '47',
  'Садерат Банк': '65',
  Смартбанк: '42',
  Трастбанк: '51',
  'Турон банк': '35',
  Узпромстройбанк: '60',
  'Универсал Банк': '33',
};

export const getBankId = (bank: string) => {
  return bankIds[bank] ?? null;
};

export const getProviderName = (bank: string) => {
  if (bank === 'Beeline') return 'beeline';
  if (bank === 'Megafon') return 'megafon';
  if (bank === 'МТС') return 'mts';
  if (bank === 'T2') return 'tele2';
  if (bank === 'Yota') return 'yota-mob';
  if (bank === 'Мотив') return 'motiv';

  return null;
};

const formatPhoneNumber = (
  phone: string,
  fromBank: DepositBank,
  method: DepositMethod,
) => {
  if (fromBank === 'ВТБ' || method === 'MOBCOM')
    return phone.replaceAll(/\D/g, '');
  return encodeURIComponent(phone.replaceAll(/[^+\d]/g, ''));
};

const formatAmount = (amount: string) => {
  return new Big(amount).toFixed(2);
};

const formatCardNumber = (cardNumber: string) => {
  return cardNumber.replaceAll(/[^+\d]/g, '');
};

export const getDeeplinks = (
  method: DepositMethod,
  transferType: DepositTransferType,
  fromBank: DepositBank,
  amount: string,
  value: string,
  toBank: string,
) => {
  const mobileOS = BrowserInfo.mobileOS;

  if (!mobileOS) return [];

  const deepLinkByBank = deepLinks[mobileOS][fromBank][method]?.[transferType];

  return (
    deepLinkByBank?.map((link) =>
      link
        .replace('{amount}', formatAmount(amount))
        .replace(
          '{phoneNumber}',
          formatPhoneNumber(value ?? '', fromBank, method),
        )
        .replace('{cardNumber}', formatCardNumber(value ?? ''))
        .replace('{qrcode}', value)
        .replace('{country}', countryCodeByMethod[method] ?? '')
        .replace('{bankId}', getBankId(toBank)?.toString() ?? '')
        .replace('{provider}', getProviderName(toBank)?.toString() ?? ''),
    ) ?? []
  );
};
